module.exports = __webpack_public_path__ + "img/huaxia_icon.db5c2b3f.png";